import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
export var MonetizationStrip = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation;
    var t = useTranslation().t;
    var promo = (_b = deviation === null || deviation === void 0 ? void 0 : deviation.extended) === null || _b === void 0 ? void 0 : _b.showStageMonetizationPromo;
    if (!promo || !['tier', 'commission'].includes(promo) || !deviation.author) {
        return null;
    }
    var biData = {
        evid: promo === 'tier'
            ? BiEventType.VIEW_SUBSCRIPTION_TAB
            : BiEventType.VIEW_COMMISSIONS_TAB,
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.ART_STAGE_PROMOTION,
    };
    return (React.createElement(PromoBanner, { className: className, size: "small", variant: "subscription", icon: React.createElement(PromoBadge, { badgeType: promo, size: 16 }), messageAfterIcon: t("deviationview.artstage.monetizationStrip.var.".concat(promo, ".body")), ctaLabel: t("deviationview.artstage.monetizationStrip.var.".concat(promo, ".CTA")), ctaHref: promo === 'tier'
            ? Url.userSubscriptionsPath({
                username: deviation.author.username,
            })
            : Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS), ctaBiData: biData }));
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
//# sourceMappingURL=MonetizationStrip.js.map